export enum UserRoles {
    ArpAccountant = 'ArpAccountant',
    ArpReviewer = 'ArpReviewer',
    ArpSupervisor = 'ArpSupervisor',
    ArpAdmin = 'ArpAdmin',
    ArpUser = 'ArpUser'
}
